import { SolarPanelLargeIcon } from './SolarPanelLargeIcon';

/**
 * author: Kristian Mohl
 * id 13BD6DBE-90E0-42A0-8FE6-A168974483CA
 * name solar-panel-large
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/solar-panel-large.svg
 * tags
 * - Home Automation 
 */
export const SolarPanelEnergyIcon = SolarPanelLargeIcon;
export default SolarPanelEnergyIcon